<template>
	<div class="vx-row">
		<div
			v-if="userRole === 'admin'"
			class="info-card vx-col lg:w-1/4 w-full mb-10"
		>
			<vx-card>
				<div class="flex justify-between items-center box-top h-full">
					<div class="des w-full">
						<span class="info-card__value"
							>{{ formattedAuthorIncome }} €</span
						>
						<p class="info-card__title">{{ $t("totalIncome") }}</p>
					</div>

					<div class="icon icon_green ml-3">
						<feather-icon
							color="#3AC47D"
							icon="CreditCardIcon"
						></feather-icon>
					</div>
				</div>
			</vx-card>
		</div>

		<div class="vx-col lg:w-1/4 w-full mb-10">
			<vx-card>
				<div class="flex justify-between items-center box-top widget">
					<div class="des w-full">
						<div class="widget__big">
							{{ countTask.count }}
						</div>
						<p>{{ $t("totalOrdersCount") }}</p>
					</div>

					<div class="icon">
						<feather-icon icon="ListIcon"></feather-icon>
					</div>
				</div>
			</vx-card>
		</div>

		<div class="vx-col lg:w-1/4 w-full mb-10">
			<vx-card>
				<div class="flex justify-between items-center box-top widget">
					<div class="des">
						<div class="widget__big">
							<span class="widget__success">
								{{ countTaskActive.count_success }}
							</span>
							/
							<span class="widget__danger">
								{{ countTaskActive.count_fail }}
							</span>
						</div>

						<p>{{ $t("success") }}</p>
					</div>

					<div class="icon">
						<feather-icon icon="ThumbsUpIcon"></feather-icon>
					</div>
				</div>
			</vx-card>
		</div>

		<div
			v-if="userRole === 'admin' && activeOrdersCount"
			class="info-card vx-col lg:w-1/4 w-full mb-10"
		>
			<vx-card>
				<div class="flex justify-between items-center box-top h-full">
					<div class="des w-full">
						<span class="info-card__value">{{
							activeOrdersCount
						}}</span>

						<p class="info-card__title">
							{{ $t("activeOrdersCount") }}
						</p>
					</div>

					<div class="icon icon_green ml-3">
						<feather-icon
							color="#3AC47D"
							icon="ListIcon"
						></feather-icon>
					</div>
				</div>
			</vx-card>
		</div>

		<div
			v-if="userRole === 'admin' && penaltyCount"
			class="info-card vx-col lg:w-1/4 w-full mb-10"
		>
			<vx-card>
				<div class="flex justify-between items-center box-top h-full">
					<div class="des w-full">
						<span class="info-card__value">{{ penaltyCount }}</span>

						<p class="info-card__title">{{ $t("penaltyCount") }}</p>
					</div>

					<div
						class="icon text-danger ml-3"
						:style="{ background: `rgba(var(--vs-danger),.15)` }"
					>
						<feather-icon
							color="#3AC47D"
							icon="CreditCardIcon"
						></feather-icon>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "AuthorsWidgets",

	props: {
		penaltyCount: {
			type: Number,
			default: 0
		},

		activeOrdersCount: {
			type: Number,
			default: 0
		},

		authorIncome: {
			type: Number,
			default: 0
		},

		countTaskActive: {
			type: Object,
			default: null
		},

		countTask: {
			type: Object,
			default: null
		}
	},

	computed: {
		userRole() {
			return this.$store.state.auth.role;
		},

    formattedAuthorIncome() {
      return this.authorIncome ? this.authorIncome.toFixed(2) : ''
    }
	}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/vuexy/variables";

.info-card {
	&_green {
		color: #54ad32;
	}

	&__value {
		font-size: 21px;
		font-weight: 600;
	}

	.icon {
		display: flex;
		align-items: center;
		padding: 13px;
		border-radius: 10px;
		font-size: 20px;

		svg {
			width: 27px;
			height: 27px;
		}

		&_green {
			color: rgb(58, 196, 125);
			background-color: #e4f6ed;
		}
	}
}

.widget {
	&__big {
		font-size: 18px;
		font-weight: 600;
	}

	&__success {
		color: $success;
	}

	&__danger {
		color: $danger;
	}
}
</style>
